<template>
    <div class="box-search">
        <input
            type="search"
            :placeholder="placeholder"
            class="input-text__fill"
            autocomplete="off"
            v-model="input"
        />
    </div>
</template>

<script>
export default {
    name: "SearchBox",
    props: {
        placeholder: String,
    },
    data() {
        return {
            input: null,
        }
    },
    watch: {
        input: function (val) {
            this.$emit('input', val)
        }
    },
    methods: {},
}
</script>

<style scoped>

</style>
